import React from 'react';
import PropTypes from 'prop-types';

const MIN_WIDTH = 1024;

class WindowSize extends React.Component {
	static propTypes = {
		children: PropTypes.func.isRequired,
	};

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	render() {
		const { children } = this.props;
		const width = Math.max(window.innerWidth, MIN_WIDTH);
		const height = window.innerHeight;
		return children({ width, height });
	}

	handleResize = () => this.forceUpdate();
}

export default WindowSize;
